import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Response = Api.Core.ClaimJob.StatusFlow.IResponse;
type Headers = Api.Core.ClaimJob.StatusFlow.IHeaders;
const url = '/api/Claims/ClaimJob/StatusFlow';
export default async function claimJobStatusFlowApi(): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.get,
    url,
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
